import { Colors, Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, states } from '@/utils'

import button from '@/components/button'
import fileManager from '@/components/file/manager'
import preloader from '@/components/preloader'
import infoButton from '@/components/services/dictionaries/buttons/info'
import filter from '@/components/services/dictionaries/filter'
import HLR from '@/components/services/dictionaries/hlr'
import item from '@/components/services/dictionaries/item'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderHLR(h) {
  return h(HLR)
}
function renderFilter(h) {
  if (this.canGet) {
    return h(
      filter,
      {
        props: {
          value: this.restData[Services.dictionaries].find.filter
        },
        on: {
          input: event => {
            this.restData[Services.dictionaries].find.filter = event
          }
        }
      }
    )
  }
}

function renderInfoButton(h, dictionaryType) {
  return h(
    infoButton,
    {
      props: {
        dictionaryType
      }
    }
  )
}
function renderPartnerButton(h, type) {
  let disabled = this.disabledUpload[type]
  if (type === DICTIONARIES['phone:mnp']) {
    disabled = this.importIsDelayed
  }

  return h(
    button,
    {
      props: {
        icon: icons.get_app,
        mode: buttonModes.flat,
        color: Colors.secondary,
        disabled,
        tooltip: this.getTranslate(`${Services.dictionaries}.tooltips.upload.partner`)
      },
      on: {
        click: () => {
          this.handlePartnerButtonClick(type)
        }
      }
    }
  )
}
function renderFileButton(h, type) {
  return h(
    button,
    {
      props: {
        icon: icons.file_upload,
        mode: buttonModes.flat,
        color: Colors.primary,
        disabled: this.disabledUpload[type],
        tooltip: this.getTranslate(`${Services.dictionaries}.tooltips.upload.file`)
      },
      on: {
        click: () => {
          this.handleFileButtonClick(type)
        }
      }
    }
  )
}
function renderActions(h, type) {
  if (this.canCreate) {
    return h(
      'div',
      {
        class: `${Services.dictionaries}-item__title__actions`
      },
      [
        renderInfoButton.call(this, h, type),
        renderPartnerButton.call(this, h, type),
        renderFileButton.call(this, h, type)
      ]
    )
  }
}
function renderTitle(h, type) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-item__title`
    },
    [
      this.getTranslate(`${Services.dictionaries}.titles.${type}`),
      renderActions.call(this, h, type)
    ]
  )
}
function renderItem(h, value) {
  return h(
    item,
    {
      props: { value },
      on: {
        action: event => {
          return this.processDictionary(event, value)
        }
      },
      key: value.id
    }
  )
}
function renderItems(h, type) {
  if (this.items[type]?.length) {
    return this.items[type].map(dictionary => {
      return renderItem.call(this, h, dictionary)
    })
  }

  return h(components.empty)
}
function renderContentByState(h, type) {
  switch (this.restData[Services.dictionaries].find.state) {
    case states.loading: return renderPreloader.call(this, h)
    case states.ready:
    default: return renderItems.call(this, h, type)
  }
}
function renderContent(h, type) {
  return h(
    components['expansion-panels'],
    {
      props: {
        outline: true,
        rounded: true
      },
      key: type
    },
    [ renderContentByState.call(this, h, type) ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${Services.dictionaries}-body`
    },
    [
      this.dictionaries.map(type => {
        return h(
          'div',
          {
            class: `${Services.dictionaries}-body__item`
          },
          [
            renderTitle.call(this, h, type),
            renderContent.call(this, h, type)
          ]
        )
      })
    ]
  )
}

function renderCompileDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showCompileDialog,
        title: this.getTranslate(`${Services.dictionaries}.titles.mix`),
        maxWidth: 400
      },
      on: {
        input: event => {
          this.showCompileDialog = event
        }
      }
    },
    [
      h(
        'div',
        {
          class: 'dialog__footer',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.no'),
                mode: buttonModes.flat,
                disabled: !this.canUpdate
              },
              on: {
                click: () => {
                  this.shouldMergePhoneRanges = false
                  this.showFileManager = true
                  this.showCompileDialog = false
                }
              }
            }
          ),
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.yes'),
                color: Colors.primary,
                disabled: !this.canUpdate
              },
              on: {
                click: () => {
                  this.shouldMergePhoneRanges = true
                  this.showFileManager = true
                  this.showCompileDialog = false
                }
              }
            }
          )
        ]
      )
    ]
  )
}

function renderFileManager(h) {
  return h(
    fileManager,
    {
      props: {
        show: this.showFileManager,
        readonly: true,
        embedded: true,
        name: false,
        maxFileSize: 524288000, // 500 mb in binary
        types: [ 'csv', 'xls', 'xlsx' ]
      },
      on: {
        show: event => {
          this.showFileManager = event
        },
        input: event => {
          this.uploadHandler(event.id)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: Services.dictionaries
    },
    [
      renderHLR.call(this, h),
      renderFilter.call(this, h),
      renderBody.call(this, h),
      renderCompileDialog.call(this, h),
      renderFileManager.call(this, h)
    ]
  )
}
